import { render, staticRenderFns } from "./NaviBlock.vue?vue&type=template&id=d33a2b5e&"
import script from "./NaviBlock.vue?vue&type=script&lang=js&"
export * from "./NaviBlock.vue?vue&type=script&lang=js&"
import style0 from "./NaviBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports